
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 3.5H.5a.5.5 0 010-1H12a.5.5 0 010 1zm11.5 18H.5a.5.5 0 010-1h23a.5.5 0 010 1zm-11.5-9H.5a.5.5 0 010-1H12a.5.5 0 010 1zm7 0a.5.5 0 01-.354-.854L22.793 7.5l-4.146-4.146a.5.5 0 01.707-.708l4.5 4.5a.5.5 0 010 .707l-4.5 4.5A.5.5 0 0119 12.5z"}})])
          )
        }
      }
    